import axios from "axios";
import axiosInstance from './interceptorService';

export const postBulkIntentDataForSamvadiniCalls = (data) => {

    const URL = `${process.env.REACT_APP_BACKEND_URL}/postBulkIntentCallData`;

    const formData = new FormData();
    formData.append('expectedLeadCount', data.expectedLeadCount);
    formData.append('sessionDuration', data.sessionDuration);
    formData.append('mitraId', data.mitraId);
    formData.append('type', data.type);
    formData.append('isManagerMitra', data.isManagerMitra);
    formData.append('files', data.files || JSON.stringify([]));

    return axiosInstance.post(URL, formData, { withCredentials: true });
};

export const getUploadedListOfFiles = ({mitraId}) => {
    return axiosInstance.get(process.env.REACT_APP_BACKEND_URL + `/intentCallingSessionList?mitraId=${mitraId}`, {withCredentials: true});
};

export const getSessionDetails = ({intentCallingSessionId}) => {
    return axiosInstance.get(process.env.REACT_APP_BACKEND_URL + `/intentCallingSessionDetails?intentCallingSessionId=${intentCallingSessionId}`, {withCredentials: true});
};

export const downloadInterestedLeads = ({intentCallingSessionId}) => {
    return axiosInstance.post(process.env.REACT_APP_BACKEND_URL + `/downloadIntentCallingSessionLeadDetails`, {intentCallingSessionId}, {withCredentials: true});
};